import * as React from 'react';

import Button from '@mui/material/Button';
import DialogContent from '@mui/material/DialogContent';
import MobileDateTimePicker from '@mui/lab/MobileDateTimePicker';
import { MenuItem, TextField } from '@mui/material';
import LocalizationProvider from '@mui/lab/LocalizationProvider';
import AdapterDateFns from '@mui/lab/AdapterDateFns';
import { useFormik } from 'formik';
import { getUser, listCompanies, listLicenses, listLicenseTypes } from '../../services/service';
import { FormDialog } from '../../components/FormDialog';
import { APISelectField } from '../APISelectField';
import TodayIcon from '@mui/icons-material/Today';
import Col from 'react-bootstrap/esm/Col';
import Row from 'react-bootstrap/esm/Row';


const defaultResponse = {
  count: 0, results: [], next: null, previous: null
}

export default function LicenseFilter(props) {
  const {
    pageSize,
    loading,
    setLicensesData,
    setLoading,
    setFilters
  } = props;
  const [open, setOpen] = React.useState(false);
  const [companyData, setCompanyData] = React.useState(defaultResponse);
  const [initialDatetime, setInitialDatetime] = React.useState(null);
  const [finalDatetime, setFinalDatetime] = React.useState(null);
  const [modelLicense, setmodelLicense] = React.useState([]);
  const [filtersState, setFiltersState] = React.useState(false);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const getCompanyFn = React.useCallback(() => {
    setLoading(true);
    listCompanies(1, 1000)
      .then((response) => {
        setCompanyData(response.data)
      })
      .catch((error) => {
        getUser({ expand: "company" }).then((res) => {
          setCompanyData({ results: [res.data["company"]] })
        }).catch((error) => {
          console.log(error)
        }).finally(setLoading(false))
      })
      .finally(setLoading(false))
  }, [])

  React.useEffect(() => {
    getCompanyFn()
  }, [])

  const getLicenseModel = React.useCallback(() => {
    listLicenseTypes().then((response) => {
      setmodelLicense(response.data.results)
    })
  })

  React.useEffect(() => {
    getLicenseModel()
  }, [])

  const callListLicenses = (props) => {
    listLicenses(
      1,
      pageSize,
      props
    ).then((response) => {
      if (response.status === 200) {
        setLicensesData(response.data)
        handleClose()
      } else {
        console.log(response.data)
      }
    }).finally((resp) => {
      setLoading(false)
    })
  }

  const formik = useFormik({
    initialValues: {
      description: "",
      hardware_key: "",
      company: "",
      license_type_slug: "",
    },
    onSubmit: (values) => {
      var filters = {}
      filters = {
        company: formik.values.company,
        created_at__gte: initialDatetime === null ? '' : initialDatetime.toISOString(),
        created_at__lte: finalDatetime === null ? '' : finalDatetime.toISOString(),
        license_type_slug: formik.values.slug_name
      }
      filters["expand"] = "license_type,company"
      setFilters(filters)
      callListLicenses(filters)
      setFiltersState(true)
    },
  })


  const clearFilter = () => {
    var filters = {
      expand: "license_type,company"
    }
    setFilters(filters)
    callListLicenses(filters)
    setFiltersState(false)
    formik.resetForm()
    setInitialDatetime(null)
    setFinalDatetime(null)
  }

  return (
    <div>
      <Row>
        <Col sm={1}>
          <Button variant="outlined" onClick={handleClickOpen}>
            Filtrar
          </Button>
        </Col>
        {
          filtersState
            ? (
              <Col sm={2}>
                <Button variant="outlined" color="error" onClick={clearFilter} type='submit' >
                  Limpar Filtro
                </Button>
              </Col>
            )
            : null
        }
      </Row>
      <FormDialog
        title={"Selecione os filtros desejados"}
        open={open}
        onDismiss={handleClose}
        formWidth={350}
        loading={loading}
        onSubmit={formik.handleSubmit}
      >
        <form onSubmit={formik.handleSubmit}>
          <DialogContent>
            <LocalizationProvider dateAdapter={AdapterDateFns}>
              <MobileDateTimePicker
                label={<div> <span>Data inicial</span> <TodayIcon style={{ marginLeft: '7rem' }} /> </div>}
                ampm={false}
                inputFormat="dd/MM/yy HH:mm"
                name="created_at__gte"
                value={initialDatetime}
                onChange={(value) => {
                  setInitialDatetime(value);
                }}
                renderInput={(params) => <TextField {...params} variant="standard" />}
              />
              <MobileDateTimePicker
                label={<div><span> Data final</span>  <TodayIcon style={{ marginLeft: '7.7rem' }} /> </div>}
                ampm={false}
                inputFormat="dd/MM/yy HH:mm"
                name="created_at__lte"
                value={finalDatetime}
                onChange={(value) => {
                  setFinalDatetime(value);
                }}
                renderInput={(params) => <TextField {...params} variant="standard" />}
              />
            </LocalizationProvider>
            <APISelectField
              id="license-company"
              name="company"
              label="Empresa"
              value={formik.values.company}
              onChange={formik.handleChange}
              disabled={loading}
            >
              <MenuItem value=''>{'Todas empresas'}</MenuItem>
              {companyData.results.map(company => (
                <MenuItem key={company.id} value={company.id}>{company.name}</MenuItem>
              ))}
            </APISelectField>
            <APISelectField
              id="license_type_slug"
              name="slug_name"
              label="Modelo de Licença"
              value={formik.values.slug_name}
              onChange={formik.handleChange}
              disabled={loading}
            >
              <MenuItem value=''>{'Todas licenças'}</MenuItem>
              {modelLicense.map(company => (
                <MenuItem key={company.slug_name} value={company.slug_name}>{company.name}</MenuItem>
              ))}
            </APISelectField>
          </DialogContent>
        </form>
      </FormDialog>
      {/* </Dialog> */}
    </div>
  );
}